import React, {FC, ReactNode} from 'react'
import {makeStyles} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import {observer} from 'mobx-react'

interface IModalDrawerProps {
    title?: ReactNode
    body?: JSX.Element | null
    footer?: JSX.Element | null
    show: boolean

    onClose(): void

    submitForm?(e: React.FormEvent): void
}

const useStyles = makeStyles({
    wrapper: {
        position: 'fixed',
        right: 0,
        top: 114,
        width: '35vw',
        height: 'calc(100% - 114px)',
        float: 'right',
        zIndex: 10,
        borderLeft: '1px solid #ddd',
        boxShadow: 'rgb(0 0 0 / 20%) 0px 2px 4px -1px, rgb(0 0 0 / 14%) 0px 4px 5px 0px, rgb(0 0 0 / 12%) 0px 1px 10px 0px',
        '&::before': {
            position: 'fixed',
            right: 0,
            top: 0,
            left: 0,
            bottom: 0,
            content: '\'\'',
            overflow: 'hidden',
            zIndex: 5,
            backgroundColor: 'rgba(255,255,255,.4)',
        },
    },
    body: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        zIndex: 10,
        backgroundColor: '#fff',
    },
    header: {
        backgroundColor: '#fff',
        borderTop: '1px solid #eee',
        borderBottom: '1px solid #eee',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '10px 15px',
        flex: 0,
    },
    headerText: {
        fontSize: 16,
        fontWeight: 600,
    },
    closeButton: {
        lineHeight: 1,
        cursor: 'pointer',
    },
    content: {
        overflow: 'auto',
        flex: 1,
        padding: '10px 15px',
        height: 0,
    },
    footer: {
        padding: '20px 15px',
        width: '100%',
        display: 'flex',
        borderTop: '1px solid #eee',
        justifyContent: 'flex-end',
        flex: 0,
        '&> .dx-button + .dx-button': {
            marginLeft: 12,
        },
    },
})

export const ModalDrawer: FC<IModalDrawerProps> = observer((props) => {
    const {show, footer, body, submitForm, title, onClose, children} = props
    const classes = useStyles()

    if (!show) return null

    const onSubmitForm = (event: React.FormEvent) => {
        event.preventDefault()
        submitForm && submitForm(event)
    }

    return (
        <div className={classes.wrapper}>
            <form className={classes.body} onSubmit={onSubmitForm}>
                <div className={classes.header}>
                    <div className={classes.headerText}>{title}</div>
                    <div
                        className={classes.closeButton}
                        onClick={onClose}
                    >
                        <CloseIcon/>
                    </div>
                </div>
                <div className={classes.content}>
                    {body}
                    {children}
                </div>
                {footer &&
                    <div className={classes.footer}>
                        {footer}
                    </div>
                }
            </form>
        </div>
    )
})